import { ElementType } from "react";

export interface Breadcrumb {
  text: string;
  route?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  icon?: ElementType;
  iconOnClick?: () => void;
}

export const getBreadCrumbs = (pathname: string, navigate: (to: string) => void) => {
  let breadcrumbArray: Breadcrumb[] = [];

  switch (pathname) {
    case "/dashboard":
      breadcrumbArray = [{ text: "Dashboard" }];
      break;
    case "/organisation":
      breadcrumbArray = [{ text: "Organization" }];
      break;
    case "/user":
      breadcrumbArray = [{ text: "User" }];
      break;
    case "/master-file":
      breadcrumbArray = [{ text: "Master File" }];
      break;
       case "/organisation-table":
      breadcrumbArray = [{ text: "Organization" }];
      break;
    default:
      breadcrumbArray = [{ text: "Dashboard", onClick: () => navigate("/organisationenve") }];
  }
  return breadcrumbArray;
}; 